module.exports = __webpack_public_path__ + "media/fonts/CircularStd-Book-d975cf2db11b0cba2bfda13134215b47.svg";